import { Grid, Link, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { EmailOutlined } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';
import { LanguageSetting } from './LanguageSetting';
import { NotificationSetting } from './NotificationSetting';
import { useAnalytics, METRICS_SUPPORT_EMAIL } from '@xolv-mybrightlink/common';

export const AccountSetting = () => {
  const analytics = useAnalytics();

  return (
    <>
      <Typography variant='subtitle1' sx={{ fontWeight: 500 }}>
        <FormattedMessage id='account.setting.title' />
      </Typography>
      <Grid container sx={{ alignItems: 'center', mt: 8 }}>
        <Grid item xs={4}>
          <Grid container spacing={2}>
            <Grid item>
              <LanguageIcon />
            </Grid>
            <Grid item>
              <Typography>
                <FormattedMessage id='account.setting.language' />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <LanguageSetting />
        </Grid>
      </Grid>
      <Grid container sx={{ alignItems: 'top', mt: 8 }}>
        <Grid item xs={4}>
          <Grid container spacing={2}>
            <Grid item>
              <NotificationsNoneIcon />
            </Grid>
            <Grid item>
              <Typography>
                <FormattedMessage id='account.setting.notify' />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <NotificationSetting />
        </Grid>
      </Grid>
      <Grid container sx={{ alignItems: 'center', mt: 8 }}>
        <Grid item xs={4}>
          <Grid container spacing={2}>
            <Grid item>
              <EmailOutlined />
            </Grid>
            <Grid item>
              <Typography>
                <FormattedMessage id='account.setting.get-help' />
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Link
            href='mailto:support@mybrightlink.org'
            onClick={() => analytics.trackAction(METRICS_SUPPORT_EMAIL)}
          >
            support@mybrightlink.org
          </Link>
        </Grid>
      </Grid>
    </>
  );
};
